module.exports = require("wrong-module");


/*****************
 ** WEBPACK FOOTER
 ** ./resolving/browser-field/~/replacing-module4/index.js
 ** module id = 2
 ** module chunks = 0
 **/